module.exports = __webpack_public_path__ + "img/fi-rr-signal-alt.cb991a77.svg";